import jsonPointer from 'json-pointer';
import isUndefined from 'lodash/isUndefined';

export default function getPointer(schema, pointer, defaultValue) {
  let normalizedSchema = schema;
  const schemaKeys = schema != null && Object.keys(schema);

  if (schemaKeys.length === 1 && schemaKeys.includes('')) {
    normalizedSchema = schema[''];
  }

  let value;
  const cleanPointer = pointer.replace(/^#?(.*)/, '$1');

  try {
    value = jsonPointer.get(normalizedSchema, cleanPointer);
  } catch (e) {
    // catch silently
  }

  return !isUndefined(value) ? value : defaultValue;
}
